import { render, staticRenderFns } from "./ModalEICProducts.vue?vue&type=template&id=330873f8&scoped=true&"
import script from "./ModalEICProducts.vue?vue&type=script&lang=js&"
export * from "./ModalEICProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330873f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('330873f8')) {
      api.createRecord('330873f8', component.options)
    } else {
      api.reload('330873f8', component.options)
    }
    module.hot.accept("./ModalEICProducts.vue?vue&type=template&id=330873f8&scoped=true&", function () {
      api.rerender('330873f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/eicproducts/ModalEICProducts.vue"
export default component.exports